exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "account-form {\n  display: block; }\n  account-form .country {\n    display: flex;\n    flex-direction: column;\n    max-width: 18rem;\n    margin-bottom: 10px; }\n    account-form .country select:disabled {\n      color: #dddddd; }\n", ""]);

// exports
